const ToolboxInfo = {
  maxInstances: {
    program_image_click_event_block: 1,
    image_setter_x_block: 1,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "program_image_click_event_block",
          },
          {
            kind: "block",
            type: "image_setter_x_block",
            inputs: {
              value: {
                shadow: {
                  type: "math_number",
                  fields: {
                    NUM: 0,
                  },
                },
              },
            },
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
